import { Button } from '@distribusion/owl-frontend-ui'
import React from 'react'

import { useTranslation } from '@lib/i18n'

import '@pages/Account/Settings/Modals/ForgotPasswordButton/index.scss'

interface ForgotPasswordButtonProps {
  onClick: () => void
}

export const ForgotPasswordButton = ({ onClick }: ForgotPasswordButtonProps) => {
  const { t } = useTranslation()

  return (
    <Button className="forgot-button" variant="text" onClick={onClick} fullWidth={false} dataTag="forgot-password-link">
      {t('account.passwordRecovery.forgotModal.title')}
    </Button>
  )
}
